import { TimeUnit } from '@mews/enums';
import { TimeUnitUtils, WallClockDateService } from '@mews/framework';
import { API_MAXIMUM_INTERVAL_MONTHS, API_MAXIMUM_INTERVAL_TIME_UNITS } from '../constants';

export const isIntervalLimitExceeded = (startDateString: string, endDateString: string, timeUnit: TimeUnit) => {
    const parsedEndDate = WallClockDateService.parse(endDateString);
    const parsedStartDate = WallClockDateService.parse(startDateString);
    const dateTime = TimeUnitUtils.timeUnitToDateTimePart(timeUnit);

    if (timeUnit === TimeUnit.Month) {
        return WallClockDateService.diff(dateTime)(parsedEndDate, parsedStartDate) > API_MAXIMUM_INTERVAL_MONTHS;
    }

    return WallClockDateService.diff(dateTime)(parsedEndDate, parsedStartDate) > API_MAXIMUM_INTERVAL_TIME_UNITS;
};
